/* eslint-disable import/extensions */
import LanguageSwitcher from '@/common/LanguageSwitcher';
import {
  I18N_LANGUAGE_EN,
  INSURANCE,
  ONE_MEDICAL,
  ProductLabel,
} from '@/constants';
import { Relationship } from '@/enums/Relationship';
import { useAppSelector } from '@/hook';
import { useProductType, useRouteSection } from '@/hooks/useRouteSection';
import EtiqalogoEFTB from '@/images/logo_EFTB.png';
import EtiqalogoEFTBBm from '@/images/logo_EFTB_BM.png';
import EtiqalogoELIB from '@/images/logo_ELIB.png';
import EtiqalogoELIBBm from '@/images/logo_ELIB_BM.png';
import { GoToHome } from '@/types/GoogleAnalytics/QuotationGA';
import { hashData } from '@/utility/common';
import { pushDataLayer } from '@/utility/googleAnalytics';
import { capitalizeFirstChar } from '@/utility/stringUtils';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { devices } from '../../theme/device';
import { withPrefix } from '@/utility/withPrefix';

const Header = () => {
  const routeSection = useRouteSection();
  const product = useProductType();
  const productLabel = ProductLabel[product];
  const isOneMedical = product === ONE_MEDICAL;

  const { t, i18n } = useTranslation();
  const { planSummary } = useAppSelector((state) => state);

  const handleGA = async () => {
    const policyowner = planSummary.quickQuoteData.applicantData.find(
      (applicant) => applicant.relationship === Relationship.Self,
    );
    const mobileNumber = planSummary.applicants.find(
      (applicant) => applicant.relationship === Relationship.Self,
    )?.contacts[0].value;
    const data: GoToHome = {
      event: 'go_to_home',
      event_category: `${productLabel} - ${capitalizeFirstChar(
        routeSection,
      )} - ${
        planSummary.quickQuoteData.applicantData.length > 1
          ? 'Family'
          : 'Individual'
      } `,
      event_action: 'Go To Home',
      event_label: 'Home',
      user_id: String(policyowner?.id) ?? undefined,
      hash_phone: (await hashData(mobileNumber ?? '')) ?? undefined,
      hash_email:
        (await hashData(policyowner?.emails.at(0)?.value ?? '')) ?? undefined,
    };
    pushDataLayer(data);
  };

  return (
    <NavbarStyle>
      <Container>
        <StylesLogo>
          <Navbar.Brand
            href="https://www.etiqa.com.my/v2/homepage"
            onClick={() => handleGA()}
          >
            {routeSection === INSURANCE ? (
              <Logo
                src={withPrefix(
                  i18n.language === I18N_LANGUAGE_EN
                    ? EtiqalogoELIB
                    : EtiqalogoELIBBm,
                )}
                alt="Logo"
                width="88px"
                height="auto"
              />
            ) : (
              <Logo
                src={withPrefix(
                  i18n.language === I18N_LANGUAGE_EN
                    ? EtiqalogoEFTB
                    : EtiqalogoEFTBBm,
                )}
                alt="Logo"
                width="88px"
                height="auto"
              />
            )}
          </Navbar.Brand>
        </StylesLogo>
        <Navbar.Toggle />
        <StylesTitle>
          {routeSection === INSURANCE
            ? t('header.insurance', { product: productLabel })
            : t('header.takaful', { product: productLabel })}
        </StylesTitle>
        <Styleslanguage>
          {isOneMedical && (
            <Navbar.Collapse className="justify-content-end">
              <LanguageSwitcher />
            </Navbar.Collapse>
          )}
        </Styleslanguage>
      </Container>
    </NavbarStyle>
  );
};

export default Header;

const NavbarStyle = styled(Navbar)`
  background-color: white !important;
`;

const StylesLogo = styled.a`
  flex: 1;
`;

const StylesTitle = styled(Navbar.Text)`
  flex: 1;
  text-align: center;
  font-weight: 700 !important;
  color: #000 !important;
  @media only screen and ${devices.xs} {
    font-size: ${(props: any) => props.theme.smallScreenBodyText2};
    display: none;
  }
  @media only screen and ${devices.lg} {
    font-size: ${(props: any) => props.theme.desktopScreenBodyText};
    display: block;
  }
`;

const Styleslanguage = styled.div`
  flex: 1;
`;

const Logo = styled.img`
  @media only screen and ${devices.xs} {
    // margin-left: 1rem;
    // width: 135px;
  }
  @media only screen and ${devices.md} {
    // margin-left: 5rem;
    // width: 169px;
  }
`;
